export interface UniversalSearchHit {
	_index: string;
	_id: number;
	_score: number;
	_source: {
		[fieldName: string]: string | number;
	};
}

export interface UniversalSearchResponse {
	total: number;
	max_score: number;
	hits: UniversalSearchHit[];
}
